import axios from 'axios'
import { Notify } from 'vant'
import Bridge from '@/libs/bridge'

let jumpAuthentication = true

const vipService = axios.create({
  baseURL: process.env.VUE_APP_VIP_API, // api的base_url
  timeout: 10000 // request timeout
})

// 封装请求拦截
vipService.interceptors.request.use(
  config => {
    let token = localStorage.getItem('token')
    let companyId = localStorage.getItem('companyId')
    if (!token || token === '' || token === 'undefined') {
      let url = window.location.search
      let theRequest = {}
      if (url.indexOf('?') !== -1) {
        let str = url.substr(1)
        let strs = str.split('&')
        for (let i = 0; i < strs.length; i++) {
          theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
        }
      }

      token = theRequest.token
      companyId = theRequest.companyId
    }

    // token = 'eyJhbGciOiJIUzI1NiJ9.eyJtb2JpbGUiOiIxMzAyMjIxMjM2OSIsImV4cCI6MjI5ODU5NzUwOSwidXNlcklkIjo0MzE1LCJpYXQiOjE2Njc4Nzc1MDksImp0aSI6ImIzMjM0ZWJhYTc5YjQzN2M4MjI4MjA0OTg2MWNkMjNhIn0.8Obc-_U8avqmwA7TDJIrAkbbaEF7RdwZ4MMK_hsVEfg'
    // companyId = '0'
    config.headers['token'] = token
    config.headers['Device-Type'] = 'YAOGONGWANG-H5'
    config.headers['companyId'] = companyId
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
vipService.interceptors.response.use(
  response => {
    if (response.status !== 200) {
      Notify({ type: 'danger', message: '请检查接口后重试' })
    } else {
      return Promise.resolve(response)
    }
  },
  error => {
    if (error.response.status === 500) {
      if (error.response.data.code === 1001) {
        // 清除缓存项目地址
        localStorage.removeItem('projectPath')
        // 登录过期，跳转登录页面
        Notify({ type: 'warning', message: '登录身份已过期，请重新登录' })
        Bridge.callHandler('jumpLogin', { isExpired: 0 }, response => {
          console.log('response:', response)
        })
      } else if (error.response.data.code === 1002) {
        // 未实名
        Notify({ type: 'warning', message: error.response.data.msg })

        let projectPath
        if (localStorage.getItem('projectPath')) {
          projectPath = JSON.parse(localStorage.getItem('projectPath'))
          projectPath.msg = error.response.data.msg
        } else {
          projectPath = {
            url: '',
            msg: error.response.data.msg
          }
        }

        if (jumpAuthentication) {
          jumpAuthentication = false
          // 清除缓存项目地址
          localStorage.removeItem('projectPath')
          Bridge.callHandler('jumpAuthentication', projectPath, response => {
            console.log('response:', response)
          })
        }

        setTimeout(function () {
          jumpAuthentication = true
        }, 500)
      }
    }
    return Promise.reject(error)
  }
)

export default vipService
